import { Link } from 'react-router-dom';

const faqs = [
  {
    q: 'Ich habe mein Passwort vergessen — was nun?',
    a: 'Schreib uns eine E-Mail mit deinem Nickname. Wir melden uns so schnell wie möglich und helfen dir beim Zurücksetzen.',
  },
  {
    q: 'Wie lade ich Freunde in einen privaten Kurs ein?',
    a: 'Öffne deinen Kurs, wechsle zum Tab „Mitglieder" und tippe auf „Mitglied einladen". Du brauchst nur den Nickname der Person.',
  },
  {
    q: 'Warum kann ich noch kein Quiz starten?',
    a: 'Ein Kurs braucht mindestens 15 Vokabeln, damit das 7-Phasen-System sinnvoll funktioniert. Füge einfach noch ein paar hinzu.',
  },
  {
    q: 'Wie lösche ich mein Konto?',
    a: 'In der App unter „Profil → Konto löschen" (Passwort zur Bestätigung erforderlich). Dein Konto und deine Lerndaten werden unwiderruflich gelöscht.',
  },
];

export default function SupportPage() {
  return (
    <div className="min-h-screen bg-paper">
      <div className="mx-auto max-w-3xl px-5 py-8 sm:py-12">
        <Link to="/" className="label-mono inline-flex h-11 items-center rounded-btn border-2 border-ink bg-cream px-3.5 !text-ink">
          ← Zurück zu VOC7
        </Link>

        <h1 className="mt-6 text-4xl font-extrabold tracking-tight sm:text-5xl">Support</h1>
        <p className="mt-3 text-lg text-body">
          Fragen, Probleme oder Feedback zu VOC7? Wir helfen gern.
        </p>

        <a
          href="mailto:support@n-mayr.net?subject=VOC7%20Support"
          className="press mt-8 inline-flex min-h-14 items-center gap-2 rounded-[16px] border-2.5 border-ink bg-marker px-6 text-lg font-bold text-ink shadow-hard"
        >
          support@n-mayr.net
        </a>
        <p className="label-mono mt-4">
          Wir antworten in der Regel innerhalb von 1–2 Tagen.
        </p>

        <h2 className="mt-12 text-3xl font-extrabold tracking-tight">
          Häufige Fragen
        </h2>
        <div className="mt-6 space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.q}
              className="ink-card p-5"
            >
              <h3 className="text-[17px] font-bold">{faq.q}</h3>
              <p className="mt-1 text-body">{faq.a}</p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-sm text-muted-foreground">
          Siehe auch:{' '}
          <Link to="/datenschutz" className="font-bold text-ink underline decoration-marker decoration-2 underline-offset-4">
            Datenschutzerklärung
          </Link>
        </p>
      </div>
    </div>
  );
}
